import React from 'react';

const DRAWER_ICON_SIZE = 36;
export const drawerIcon = (Svg: any) => () => (
  <Svg width={DRAWER_ICON_SIZE} height={DRAWER_ICON_SIZE} />
);
